
export const inputSpacing = 5;
export const sectionVerticalSpacing = 40;

export const grey = '#f4f4f4';

export const styles = {
  stepHeading: {
    fontSize: '23px',
    color:'black'
  },
  courseHeading: {
    fontSize: 20,
    color:'grey'
  }
};




/** WEBPACK FOOTER **
 ** ./components/race/create/styles.js
 **/